import getInstance from "../config/api";

export default class Contract {
  static async fetchContracts(params) {
    const instance = getInstance();
    const { data } = await instance.get("/contract", { params });
    return data;
  }

  static async fetchContractsHistory(params) {
    const instance = getInstance();
    const { data } = await instance.get("/contract/get-history-by-document", {
      params,
    });
    return data;
  }

  static async fetchContractsConsolidated(params) {
    const instance = getInstance();
    const { data } = await instance.get("/contract/grouped", { params });
    return data;
  }

  static async downloadEvidence(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/download-evidence`);
    return data;
  }

  static async downloadContract(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/download`);
    return data;
  }
  static async downloadPreContractsConsolidated(params) {
    const instance = getInstance();
    const data = await instance.get("/contract/grouped-csv", { params });
    return data;
  }

  static async fetchContractById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/contract/${id}`);
    return data;
  }

  static async fetchContractsByUserId(userId) {
    const instance = getInstance();
    const { data } = await instance.get(`/contract/user`, {
      params: { userId },
    });
    return data;
  }

  static async cancelInstallments(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/contract/cancel-installments`, body);
    return data;
  }

  static async updateContractId(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/contract/update-contract`, body);
    return data;
  }

  static async updateContractStatus(body) {
    const instance = getInstance();
    const { data } = await instance.post(
      `/contract/update-contract-status`,
      body
    );
    return data;
  }
  static async fetchContractKobana(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/create-client-kobana`);
    return data;
  }

  static async fetchContractPDF(id) {
    const instance = getInstance();
    const data = await instance.get(`/contract/${id}/create-contract-file`);
    return data;
  }

  static async importCsvStorages(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/contract/csv`, body);
    return data;
  }

  static async registerDebtLetterBatch(body) {
    const instance = getInstance();
    const { data } = await instance.post(
      `/contract/register-debit-letter-batch`,
      body
    );
    return data;
  }

  static async fetchDebtLetterBatchImports(params) {
    const instance = getInstance();
    const { data } = await instance.get(
      `/contract/get-debit-clearance-history`,
      {
        params,
      }
    );
    return data;
  }

  static async downloadSettlementLetter(body) {
    const instance = getInstance();
    const { data } = await instance.post(
      `/contract/create-debit-clearance-letter-file`,
      body
    );
    return data;
  }

  static async getDebtClearanceLetterFile(debitLetterFileId) {
    const instance = getInstance();
    const { data } = await instance.get(
      `/contract/get-debit-clearance-letter-file/${debitLetterFileId}`
    );
    return data;
  }

  static async getExactAmount(params) {
    const instance = getInstance();
    const queryParams = new URLSearchParams({
      contractExternalId: params.contractExternalId,
      date: params.date,
      contractId: params.contractId,
      ...(params.reason && { reason: params.reason }),
      ...(params.installmentsNumber && {
        installmentsNumber: params.installmentsNumber,
      }),
    }).toString();
    const { data } = await instance.get(
      `/contract/get-exact-amount?${queryParams}`
    );
    return data;
  }

  static async checkInstallmentDependencies(contractId, installmentNumbers) {
    const instance = getInstance();
    const { data } = await instance.post(`/contract/confirm-cancellation`, {
      contractId,
      installmentNumbers,
    });
    return data;
  }

  static async fetchContractIdByExternalId(contractExternalId) {
    const instance = getInstance();

    const { data } = await instance.get(`/contract/contract-external`, {
      params: { contractExternalId },
    });

    return data;
  }

  static async sendNotificationToInsurance(params) {
    const instance = getInstance();
    const { data } = await instance.post(`/contract/publish-queue`, params);
    return data;
  }

  static async fetchInstallmentSettlementFiles(params) {
    const instance = getInstance();
    const response = await instance.get(
      "/contract/get-installment-settlement-files",
      { params }
    );
    return response.data;
  }

  static async fetchInstallmentSettlementFileControls(id) {
    const instance = getInstance();
    const response = await instance.get(
      `/contract/${id}/get-installment-settlement-file-controls`
    );
    return response.data;
  }

  static async uploadInstallmentSettlement(body) {
    const instance = getInstance();
    const response = await instance.post(
      "/contract/upload-installment-settlement",
      body
    );
    return response.data;
  }
}
